import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tools--form"
export default class extends Controller {
  static targets = ["form", "tab", "pane"]

  connect() {
    this.updateBreadcrumb();
    this.activateDefaultTab();
  }

  updateBreadcrumb() {
    const code = this.formTarget.querySelector(`input[name$="[code]"]`).value;
    const name = this.formTarget.querySelector(`input[name$="[name]"]`).value;
    const breadcrumbText = `${code} ${name}`;

    document.querySelector(".master-page .crumb").innerHTML = `マスタ ＞ 機械 ＞ ${breadcrumbText}`;
  }

  switchTab(event) {
    const selected = event.currentTarget.dataset.tab
    this.activateTab(selected)
  }

  activateDefaultTab() {
    const activeTab = this.tabTargets.find(tab =>
      tab.classList.contains("active")
    )

    if (activeTab) {
      this.activateTab(activeTab.dataset.tab)
    }
  }

  activateTab(selected) {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tab === selected)
    })

    this.paneTargets.forEach(pane => {
      pane.style.display =
        pane.dataset.pane === selected ? "block" : "none"
    })
  }
}
